import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';

export const Wrapper = styled(Box)`
  background: white;
  ${({ theme }) => css`
    margin-top: ${theme.spacing(1.5)};
  `}
`;

export const Header = styled.header`
  height: 100%;
  width: 100%;
  ${({ theme }) => css`
    border-bottom: 0.5px solid ${theme.colors.lightGray};
  `}
`;

export const HeaderContent = styled(Flex)<{ isOpen: boolean }>`
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 40px;
  background-color: transparent;
  p {
    margin-right: 8px;
  }
  color: ${({ isOpen, theme }) =>
    isOpen ? theme.colors.white : theme.colors.primaryDark};

  background-color: ${({ isOpen, theme }) =>
    isOpen ? theme.colors.primaryDark : theme.colors.secondaryLightGrey};

  svg {
    color: ${(props) => props.theme.colors.primary};
  }
`;

export const Content = styled.div<{
  contentHeight: number;
  isOpen: boolean;
}>`
  overflow: hidden;
  height: ${(props) => (props.isOpen ? '100%' : `${0}px`)};
  transition: height 0.3s ease;
`;
